<template>
  <div v-if="bannerVisible" class="reports-banner-wrapper form-inline">
    <div class="reports-banner">
      <div class="content">
        <i class="fa fa-bar-chart"></i> Get a report like this for any hashtag: &nbsp;&nbsp;&nbsp;
        <div class="input-group">
          <div class="input-group-addon">#</div>
          <input
            v-model="hashtag"
            id="hashtag"
            type="text"
            class="form-control"
            placeholder="type a hashtag here"
          >
          <span class="input-group-btn">
            <button @click="goToHashtag" id="goto" class="btn btn-default">Continue</button>
          </span>
        </div>
        <span class="close-button" @click="close">
          <sup>
            <i class="fa fa-close"></i>
          </sup>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ReportsBanner',
  data() {
    return {
      bannerVisible: true
    }
  },
  methods: {
    goToHashtag() {
      if (this.hashtag) {
        document.location.href = `${process.env.RITETAG_URL}/hashtag-stats/` + this.hashtag.replace('#', '');
      }
      else {
        document.location.href = `${process.env.RITETAG_URL}/hashtag-reports/`
      }

    },
    close() {
      this.bannerVisible = false;
    }
  },
}
</script>

<style scoped lang="scss">
.reports-banner-wrapper {
  position: fixed;
  bottom: 20px;
  left: 0px;
  padding: 0px 10px;
  width: 100%;
  z-index: 10000;
  pointer-events: none;
  text-align: center;
  .reports-banner {
    background-color: #c12f93; // TODO: $ritekit-main;
    color: white;
    border-radius: 4px;
    pointer-events: all;
    display: inline-block;
    .content {
      position: relative;
      padding: 10px 35px 10px 20px;

      #hashtag {
        width: 160px;
        height: 37px;
      }
      .input-group {
        margin-top: 6px;
        margin-right: 5px;
      }
      .close-button {
        cursor: pointer;
        position: absolute;
        top: 0px;
        right: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ReportsBanner.vue